
export class MtmaModule {
    Max?: number;
    Description?: string;
    FWVersion?: string;
    FWVersionBL?: string;
    FWVersionLTE?: string;
    Id?: number;
    Name: string;
    Position: number;
    Type: number;
    Config?: MtmaModuleConfig;
}

export class MtmaEditModule {
    Module?: MtmaModule;
    Section: string;
}

export class MtmaModuleConfig {
    Buttons?: string[];
    EnAlphaSearch?: number;
    EnStandby?: number;
    EnTones?: number;
    In1Func?: number;
    Lang?: number;
    Layout?: number;
    LcdColor?: number;
    LcdLevel?: number;
    LedColor?: number;
    LedLevel?: number;
    Messages?: any;
    MicLevel?: number;
    SearchInt?: number;
    SearchIntLimit?: number;
    SpkLevel?: number;
    StandbyLevel?: number;
    TCall?: number;
    TLock?: number;
    TRelay?: number;
    TRing?: number;
    WelcomeMsg?: string[];
    UseMode?: number;
    CodeLen?: number;
    EnableLogAccess?: number;
    EnableLogCall?: number;
    EnableLogSystem?: number;
    In1Notify?: number;
}

export class MtmaSettingsModules {
    ModuleType: number;
    ListSettings: MtmaModuleSetting[];
}

export class MtmaModuleSetting {
    Name: string;
    Type: string;
    Values?: any;
    Default?: number;
    StepSize?: number;
    DisplayScale?: number;
    Offset?: number;
    Min?: number;
    Max?: number;
    Length?: number;
    List?: string[];
}


export interface MtmaSettingValue {
    Value: string;
    Description: string;
    Label: string;
}

export class MtmaChangesConfig {
    Changes: boolean;
}


export class MtmaCloneFlag {
    Modules: boolean;
    ContactsUnits: boolean;
    Dtmfs: boolean;
    Tags: boolean;
    Keypads: boolean;
    RulesAccess: boolean;
    Automation: boolean;
}
